<template>
    <div class="record">
        <z-title title="咨询记录" ref="title"></z-title>
        <el-card  ref="search">
            <div class="flex-n fac fjb content1">
            <el-button type="primary" class="ele-btn1 mr-10" @click="addConsult">新增咨询</el-button>
            <el-input
                    size="medium"
                    class="ele-input mr-10"
                    placeholder="输入姓名"
                    maxlength="20"
                    title="输入要搜索的姓名"
                    clearable
                    prefix-icon="el-icon-search"
                    v-model="customName">
            </el-input>
            <el-input
                    size="medium"
                    class="ele-input mr-10"
                    type="number"
                    placeholder="输入电话号码"
                    title="输入电话号码"
                    clearable
                    prefix-icon="el-icon-search"
                    maxlength="11"
                    v-model="phone">
            </el-input>
            <div class="textnowrap">意向日期：</div>
            <el-date-picker
                    size="medium"
                    class="mr-10 date"
                    v-model="dateRange"
                    value-format="yyyy-MM-dd"
                    type="daterange"
                    range-separator="至"
                    :picker-options="pickerOptions"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
            >
            </el-date-picker>
            <div class="textnowrap">意向度：</div>
            <want-level clearable class="mr-10" size="medium"  v-model="wantLevel" placeholder="请选择"></want-level>
            <div  class="textnowrap">跟进状态：</div>
            <follow-state clearable  class="mr-10" size="medium" v-model="followState"  placeholder="请选择"></follow-state>
            <el-button type="primary" class="ele-btn2" @click="searchAskList">查询</el-button>
            </div>
        </el-card>
        <el-card class="mt-10">
            <el-table
                    v-loading="loading"
                    :height="height+'px'"
                    highlight-current-row
                    element-loading-text="列表刷新中"
                    header-cell-class-name="headerrow"
                    cell-class-name="cellclass"
                    :data="dataList"
                    style="width: 100%">
                <el-table-column
                        fixed
                        align="center"
                        prop="customName"
                        label="姓 名"
                        width="120">
                </el-table-column>
                <el-table-column
                        prop="phone"
                        label="电 话"
                        min-width="150"
                        align="center">
                </el-table-column>
                <el-table-column
                        prop="wechatNo"
                        label="微 信"
                        align="center"
                        min-width="150">
                </el-table-column>
                <el-table-column
                        prop="createTime"
                        label="来访日期"
                        align="center"
                        min-width="180">
                </el-table-column>
                <el-table-column
                        prop="wantCount"
                        label="人 数"
                        align="center">
                </el-table-column>
                <el-table-column
                        prop="wantDate"
                        label="意向日期"
                        align="center"
                        min-width="120">
                </el-table-column>
                <el-table-column
                        label="时间段"
                        width="100"
                        align="center">
                    <template slot-scope="scope">
                        {{scope.row.wantBeginTime?(scope.row.wantBeginTime+'-'+scope.row.wantEndTime):''}}
                    </template>
                </el-table-column>
                <el-table-column
                        label="意向场地"
                        min-width="180"
                        prop="wantHouseContent"
                        align="center">
                </el-table-column>
                <el-table-column
                        prop="budget"
                        label="预 算"
                        min-width="120"
                        align="center">
                </el-table-column>
                <el-table-column
                        prop="wantLevel"
                        label="意向度"
                        align="center">
                    <template slot-scope="scope">
                        <template v-for="item,index in wantLevelList" v-if="item.dicCode==scope.row.wantLevel">
                            {{item.dicName}}
                        </template>
                    </template>
                </el-table-column>
                <el-table-column
                        label="跟进状态"
                        align="center">
                    <template slot-scope="scope">
                        <template v-for="item,index in followStateList" v-if="item.dicCode==scope.row.followState">
                            {{item.dicName}}
                        </template>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="customFromName"
                        label="来 源"
                        align="center">
                </el-table-column>
                <el-table-column
                        label="回访日期"
                        align="center"
                        prop="callbackDate"
                        min-width="180">
                </el-table-column>
                <el-table-column
                        prop="createUserName"
                        label="经办人"
                        min-width="120"
                        align="center">
                </el-table-column>
                <el-table-column
                        fixed="right"
                        label="操作"
                        width="140"
                        align="center">
                    <template slot-scope="scope">
                        <el-button type="text" size="small" @click="editConsult(scope.row.id)" v-if="scope.row.followState=='01'||scope.row.followState=='02'">编辑</el-button>
                        <template v-if="!scope.row.callbackDate">
                        <el-button type="text" size="small"  @click="gotoHandle(scope.row.id,null)">处理明细</el-button>
                        </template>
                        <template v-else>
                            <el-button type="text" size="small" @click="editReserve(scope.row)" v-if="scope.row.followState=='01'||scope.row.followState=='02'">预定</el-button>
                            <el-button type="text" size="small"  @click="gotoHandle(scope.row.id,scope.row.wantDate)">处理</el-button>
                        </template>
                    </template>
                </el-table-column>
            </el-table>
            <!--分页-->
            <pagination :current-page="currentPage" :page-size="pageSize" :total="total"   @sizeChange="handleSizeChange"
                        @currentChange="handleCurrentChange"></pagination>
        </el-card>
        <!--编辑咨询-->
        <consultation :visible.sync="showdialog" v-model="dataForm" @refresh="refresh" :type="editstate" :id="id"></consultation>
        <!--处理明细-->
        <!--<processdetails :visible.sync="showconsult" :id="askId" :consult-info="consultInfo"></processdetails>-->
        <!--处理咨询-->
        <handle-consult :visible.sync="showconsult" :id="askId" :wantDate="wantDate" @change="consultChange"></handle-consult>




        <!--预定-->
        <books :visible.sync="showorder" v-model="orderForm" type="新增"  @refresh="refresh" ></books>
    </div>
</template>

<script>
    import ZTitle from "../../components/ZTitle";
    import Consultation from "../component/consultation";
    import Processdetails from "../component/processdetails";
    import WantLevel from "../../components/data/wantLevel";
    import FollowState from "../../components/data/followState";
    import Books from "../component/books";
    import WantHouse from "../../components/data/wantHouse";
    import HandleConsult from "./sub/handleConsult";
    import Pagination from "../../components/pagination/pagination";
    export default {
        components: {
            Pagination,
            HandleConsult,
            WantHouse,
            FollowState,
            WantLevel,
            Books,
            Processdetails,
            Consultation,
            ZTitle},
        name: "record",
        data(){
            return{

                loading: false,
                pageSize: 20,
                currentPage: 1,
                total: 0,
                height: 250,
                dataForm: {},
                editstate: '新增',
                
                orderForm:{},
                showorder:false,
                
                customName:'',
                phone:'',
                dateRange:[], //意向度日期范围
                wantLevel:'', //跟进状态
                followState:'',
                id:'',
                askId:'',
                followStateList:[],
                wantLevelList:[],
                //处理咨询
                handleForm: {
                    followState: '',//后台未定义
                    wantLevelCode: '',
                    callbackDate: '',
                    wantHouse: [],
                    remark: ''
                },
                //待处理咨询规则
                rules: {},
                checkedAlert:false,
                detailData: [],

                showdialog:false,
                showconsult:false,
                dataList:[],
                wantHouse:[],
                consultInfo:{},
                wantDate:'',
            }
        },
        computed:{
            pickerOptions() {
                var that=this;
               return{
                   firstDayOfWeek: 1,
                   shortcuts: [
                       {
                           text: '今日',
                           onClick(picker) {
                               const end = new Date();
                               const start = new Date();
                               picker.$emit('pick', [start, end]);
                           }
                       },
                       {
                           text: '昨日',
                           onClick(picker) {
                               const end = new Date();
                               const start = new Date();
                               start.setTime(start.getTime() - 3600 * 1000 * 24);
                               end.setTime(end.getTime() - 3600 * 1000 * 24);
                               picker.$emit('pick', [start, end]);
                           }
                       },
                       {
                           text: '本周',
                           onClick(picker) {
                               const end = new Date();
                               const start = new Date();
                               var num=start.getDay();
                               if(num==0){
                                   num=7;
                               }
                               start.setTime(start.getTime() - 3600 * 1000 * 24 * (num-1));
                               end.setTime(end.getTime() + 3600 * 1000 * 24 * (7-num));
                               picker.$emit('pick', [start, end]);
                           }
                       },
                       {
                           text: '上周',
                           onClick(picker) {
                               const end = new Date();
                               const start = new Date();
                               var num=start.getDay();
                               if(num==0){
                                   num=7;
                               }
                               start.setTime(start.getTime() - 3600 * 1000 * 24 * (num+6));
                               end.setTime(end.getTime() - 3600 * 1000 * 24 * num);
                               picker.$emit('pick', [start, end]);
                           }
                       },
                       {
                           text: '本月',
                           onClick(picker) {
                               const start = new Date();
                               var year=start.getFullYear(),month=start.getMonth()+1;
                               var startDate=new Date(year+'-'+month+'-1');
                               var length=that.$TM.getMonthArea().length-1;
                               var dd=that.$TM.getMonthArea()[length].dd;
                               var endDate= new Date(that.$TM.getMonthArea()[length-(dd<7?dd:0)].date);
                               console.log(startDate,endDate)
                               picker.$emit('pick', [startDate, endDate]);
                           }
                       },
                       {
                           text: '上月',
                           onClick(picker) {
                               const start = new Date();
                               console.log(that.$TM.beforeMouth({yy:start.getFullYear(),mm:start.getMonth()+1,dd:1}))
                               var month=that.$TM.beforeMouth({yy:start.getFullYear(),mm:start.getMonth()+1,dd:1})[15].mm,
                               year=that.$TM.beforeMouth({yy:start.getFullYear(),mm:start.getMonth()+1,dd:1})[15].yy;
                               var length=that.$TM.beforeMouth({yy:start.getFullYear(),mm:start.getMonth()+1,dd:1}).length-1;
                               var dd=that.$TM.beforeMouth({yy:start.getFullYear(),mm:start.getMonth()+1,dd:1})[length].dd;
                               var startDate=new Date(year+'-'+month+'-1');
                               var endDate= new Date(that.$TM.beforeMouth({yy:start.getFullYear(),mm:start.getMonth()+1,dd:1})[length-(dd<7?dd:0)].date);
                               // console.log(startDate,endDate)
                               picker.$emit('pick', [startDate, endDate]);
                           }
                       }
                      ]
               }
            },

        },
        mounted(){
            setTimeout(()=>{
                this.height=document.body.offsetHeight -this.$refs.title.$el.offsetHeight-this.$refs.search.$el.offsetHeight - 200;
                console.log(this.height)
            },0)
            var date=this.$TM.getDayArea();
            var mm=date.mm,yy=date.yy;
            if(mm==12){
                mm=1;
                yy++;
            }
            var date2=new Date(new Date(this.$TM.getDayArea(yy,mm+1,1).date).getTime()-24*60*60*1000);            this.dateRange=[date.yy+'-'+date.mm+'-1',date2.getFullYear()+'-'+(date2.getMonth()+1)+'-'+date2.getDate()];
            this.dateRange=[date.yy+'-'+date.mm+'-1',date2.getFullYear()+'-'+(date2.getMonth()+1)+'-'+date2.getDate()];
            this.getDataList();
        },
        methods: {
            //咨询处理改变
            consultChange(){
                this.getDataList();
            },
            //编辑预定
            editReserve(row) {
                var wanthouse={};
                for(var i in row.wantHouse){
                    if(row.wantHouse[i]){
                        wanthouse=row.wantHouse[i];
                        break;
                    }
                }
                this.$set(this.orderForm,'customName',row.customName);
                this.$set(this.orderForm,'phone',row.phone);
                this.$set(this.orderForm,'orderDate',row.wantDate);
                this.$set(this.orderForm,'houseId',wanthouse.houseId||'');
                this.$set(this.orderForm,'houseTypeCode',wanthouse.house_type_code||'');
                this.$set(this.orderForm,'askId',row.id);
                this.showorder = true;
            },
            //根据咨询记录id查看处理明细,显示10条
            gotoHandle(askId, wantDate) {
                console.log(askId)
                this.wantDate = wantDate;
                this.askId = askId;
                this.showconsult = true;
            },

            refresh(){
                if(this.editstate=='新增')
                {
                    this.currentPage=1;
                }
                this.getDataList();
            },
            //查询咨询记录列表
            getDataList(){
                this.loading=true;
                this.$axios.post('/preUserAsk/askList',{
                    storeId: this.$root.getStorage('storeId'),
                    customName:this.customName,
                    phone:this.phone,
                    startTime:this.dateRange?this.dateRange[0]:'',
                    endTime:this.dateRange?this.dateRange[1]:'',
                    wantLevel:this.wantLevel,
                    followState:this.followState,
                    currentPage:this.currentPage,
                    pageSize:this.pageSize
                }).then(res=>{
                    this.loading=false;
                    console.log('咨询记录列表',res)
                    this.dataList=res.data.list;
                    for(var i in this.dataList){
                        var content='';
                       for(var j in this.dataList[i].wantHouse){
                           if(this.dataList[i].wantHouse[j]){
                               content +=this.dataList[i].wantHouse[j].houseName+'、'
                           }
                       }
                       if(content.length>0){
                           this.$set(this.dataList[i],'wantHouseContent',content.substring(0,content.length-1))
                       }
                    }
                    this.total = res.data.total;
                    this.getStateList();

                }).catch(err=>{
                    this.$message.error(err.msg);
                    this.loading=false;
                })
            },
           getStateList(){
                if(this.$root.getStorage('dic')){
                    this.followStateList=this.$root.getStorage('dic').filter((item)=>item.dicType=='follow_state');
                    this.wantLevelList=this.$root.getStorage('dic').filter((item)=>item.dicType=='want_level');
                }else{
                    this.$store.state.dicChange=true;
                    this.getDataList();
                }
           },
            //搜索
            searchAskList(){
                this.currentPage=1;
                this.getDataList();
            },
            //新增
            addConsult(){
                this.showdialog=true;
                this.editstate='新增';
            },
            //编辑
            editConsult(id){
                console.log('编辑',id)
                this.id=id;
                this.editstate='编辑';
                this.$axios.get('/preUserAsk/findById/'+id).then(res=>{
                    console.log('编辑查看数据',res)
                    var data=res.data;
                    var wantHouse=[]
                    for(var i in data.wantHouse){
                        if(data.wantHouse[i])
                      wantHouse.push({id:data.wantHouse[i].houseId,houseName:data.wantHouse[i].houseName})
                    }
                    data.wantHouse=wantHouse;
                    data.userFrom={
                        dicCode:data.customFromId,
                        dicName:data.customFromName
                    }
                    this.dataForm=data;
                    this.showdialog=true;
                }).catch(err=>{
                    this.$message.error(err.msg);
                })
            },
            handleSizeChange(val) {
                this.pageSize=val;
                this.getDataList();
                console.log(`每页 ${val} 条`);
            },
            handleCurrentChange(val) {
                this.currentPage=val;
                this.getDataList();
                console.log(`当前页: ${val}`);
            },
        },
    }
</script>

<style scoped lang="scss">
.record{
    .content1{
        .textnowrap{
            font-size: 13px;
            color: #333;
        }
        .date{
            min-width: 100px;
        }
    }
}
</style>